import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
// import { reducer as notificationsReducer } from 'reapop'

import reducerAuth from './reducers/reducerAuth'
import reducerCallAPI from './reducers/reducerCallAPI'
import userReducer from './reducers/user'
import qrTagReducer from './reducers/qrtag'

export default combineReducers({
    form: formReducer,
    // notifications: notificationsReducer(),
    authen: reducerAuth.authen,
    users: userReducer.users,
    user: userReducer.user,
    callAPI: reducerCallAPI.reducerCallAPI,
    errorList: reducerCallAPI.errorList, //Error list from API
    isLoading: reducerCallAPI.isLoading,
    tagDatas: qrTagReducer.tagDatas,
    tagData: qrTagReducer.tagData,
})


// WEBPACK FOOTER //
// ./src/app/redux/reducers.js